import { ArrowDown } from '@ui/components/icons';
import { NoSSR } from '@ui/components/NoSSR';
import { PercentageSplitLine } from '@ui/components/PercentageSplitLine';
import { StatLabel } from '@ui/components/Stats';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { useOpenInterest } from '@ui/hooks/trade/useOpenInterest';
import { Collapsible } from '@ui/lib/park/ui/collapsible';
import { Icon } from '@ui/lib/park/ui/icon';
import { useTranslation } from 'next-i18next';
import { Flex } from 'styled-system/jsx';

import { DayStats } from './DayStats';
import { HighLow24hCollapseStat } from './HighLow24h';
import { OpenInterests } from './OpenInterests';

export const CollapseStats = () => {
  return (
    <>
      <PairInfoContent />
    </>
  );
};

const PairInfoContent = () => {
  return (
    <>
      {/* <DayStats mt={2} /> */}
      <OpenInterests />
    </>
  );
};
